import useSWR from 'swr'
import { useAxiosApi } from './useAxiosApi'

export default function useComments(commentableType, commentableId) {
    const { requestGet, requestPost, requestPatch, requestDelete } = useAxiosApi()

    const key = commentableType && commentableId
        ? `/comments?commentable_type=${commentableType}&commentable_id=${commentableId}`
        : null

    const { data, isLoading, mutate } = useSWR(key, (url) => {
        const params = new URLSearchParams(url.split('?')[1])
        return requestGet('/comments', Object.fromEntries(params))
    })

    const comments = data?.data ?? []

    const addComment = async (content) => {
        await requestPost('/comments', {
            content,
            commentable_type: commentableType,
            commentable_id: commentableId,
        })
        mutate()
    }

    const updateComment = async (commentId, content) => {
        await requestPatch(`/comments/${commentId}`, { content })
        mutate()
    }

    const deleteComment = async (commentId) => {
        await requestDelete(`/comments/${commentId}`)
        mutate()
    }

    return {
        comments,
        isLoading,
        mutate,
        addComment,
        updateComment,
        deleteComment,
    }
}
